import { render, staticRenderFns } from "./Shixun.vue?vue&type=template&id=04cdc254&scoped=true&"
import script from "./Shixun.vue?vue&type=script&lang=js&"
export * from "./Shixun.vue?vue&type=script&lang=js&"
import style0 from "./Shixun.vue?vue&type=style&index=0&id=04cdc254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cdc254",
  null
  
)

export default component.exports